import { getQueryString } from '../utils';
import eventEmitter from '../utils/eventEmitter';

const request = async (params) => {
  const method = params.method || 'GET';
  let qs = '';
  let body;
  const headers = params.headers || {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  if (['GET'].indexOf(method) > -1 && params.data) {
    qs = `?${getQueryString(params.data)}`;
  } else {
    // POST or PUT or DELETE
    body = JSON.stringify(params.data);
  }

  const fetchOptions = {
    method,
    headers,
    body,
  };

  if (params.signal) fetchOptions.signal = params.signal;

  const url = params.url + qs;
  try {
    const response = await fetch(`/api/v2${url}`, fetchOptions);
    let result;
    if (params.binary) {
      result = await response.blob();
    } else {
      result = await response.json();
      result.status_code = response.status;
    }

    if (result.not_authenticated) {
      eventEmitter.emit('sessionExpired');
    }
    return result;
  } catch (error) {
    return error;
  }
};

const getRecaptchaKey = async () => {
  try {
    const response = await request({
      method: 'GET',
      url: '/recaptcha_key',
    });
    return response;
  } catch (error) {
    throw error;
  }
};
const consoleApi = {
  get: (params) => request({ ...params, method: 'GET' }),
  post: (params) => request({ ...params, method: 'POST' }),
  put: (params) => request({ ...params, method: 'PUT' }),
  delete: (params) => request({ ...params, method: 'DELETE' }),
  getRecaptchaKey,
};

export default consoleApi;
